import * as React from "react";
import { PopoverProps } from "@mui/material/Popover";
import { usePatientCase } from "./usePatientCase";
import { useDiagnosticNavigation } from "./useDiagnosticNavigation";
import { MobileSupportedContextMenu } from "./common/mobileSupportedContextMenu";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface DDActionsMenuProps {
  className?: string;
  id?: string;
  open: boolean;
  anchorEl?: PopoverProps["anchorEl"];
  onClose: () => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DDActionsMenu = ({ onClose, ...props }: DDActionsMenuProps) => {
  const { setAddDiseaseOpen } = useDiagnosticNavigation();

  const {
    resetPlan,
    patientCase: {
      diseasesToAdd,
      diseasesToRemoveFromPlan,
      diseasesToIncludeInPlan,
    },
  } = usePatientCase();

  const planNotChanged =
    !diseasesToIncludeInPlan?.length &&
    !diseasesToRemoveFromPlan?.length &&
    !diseasesToAdd?.length;

  const handleAddDisease = () => {
    evt({
      category: CATEGORY.AGENT_DD_LIST,
      action: ACTION.OPEN_ADD_DISEASE_SEARCH,
    });
    setAddDiseaseOpen(true);
  };

  const handleRestoreDefaultDDList = () => {
    evt({
      category: CATEGORY.AGENT_DD_LIST,
      action: ACTION.RESET_PLAN,
    });
    resetPlan();
  };

  const menuActions = [
    {
      text: "Add Disease",
      action: handleAddDisease,
      disabled: false,
    },
    {
      text: "Restore default DD list",
      action: handleRestoreDefaultDDList,
      disabled: planNotChanged,
    },
  ];

  return (
    <MobileSupportedContextMenu
      className={props.className}
      anchorEl={props.anchorEl}
      open={props.open}
      onClose={onClose}
      id={props.id}
      actions={menuActions}
    />
  );
};
